import { render } from "./UserLoginLogs.vue?vue&type=template&id=072b95c7"
import script from "./UserLoginLogs.vue?vue&type=script&lang=js"
export * from "./UserLoginLogs.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/logs/UserLoginLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "072b95c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('072b95c7', __exports__)) {
    console.log('reload')
    api.reload('072b95c7', __exports__)
  }
  
  module.hot.accept("./UserLoginLogs.vue?vue&type=template&id=072b95c7", () => {
    console.log('re-render')
    api.rerender('072b95c7', render)
  })

}


export default __exports__